module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/mailchimp/subscriber/shared/subscriber-form/subscriber-form.component.scss
// module id = ./src/app/mailchimp/subscriber/shared/subscriber-form/subscriber-form.component.scss
// module chunks = main